import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import cn from 'classnames';

import { Services, Table } from 'services/action';
import { Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  service: null,
  name: null,
  pricing_schema: null,
  min_weight: null,
  dividers: null,
  options: null,
  isLoading: true,
};

let divide = [
  { value: '4000', label: '4000' },
  { value: '6000', label: '6000' },
  { value: '1000000', label: '1000000' },
];

const initialOptions = [
  { value: 'weight_point_based', label: 'Berbasis Berat per Titik' },
  { value: 'weight_based', label: 'Berbasis Berat' },
  { value: 'trip_based', label: 'Berbasis Perjalanan' },
  { value: 'colly_based', label: 'Berbasis Koli' },
  { value: 'dedicated_monthly', label: 'Berbasis Dedicate Perbulan' },
  { value: 'dedicated_daily', label: 'Berbasis Dedicate Perhari' },
];

const FormInput = ({ data, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['service_type']);

  const dummy = Array.from({ length: 2 }, (v, i) => i);

  const [
    { dividers, min_weight, name, pricing_schema, service, isLoading },
    setState,
  ] = React.useState(initialState);

  const $handleSubmit = async (c) => {
    const payload = {
      service_id: service?.id,
      name: name,
      pricing_schema: pricing_schema?.value,
      min_weight: min_weight ? parseFloat(min_weight) : null,
      dividers: dividers ? parseFloat(dividers?.value) : null,
    };

    if (data) {
      const submit = await Dispatch(Services.$updateType(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();

        Dispatch(Table.$reload('service_type', StateTable));
      }
    } else {
      const submit = await Dispatch(Services.$createType(payload));
      if (submit?.message === 'success') {
        onClose();

        Dispatch(Table.$reload('service_type', StateTable));
      }
    }
  };

  const $handleChangeDivider = (d) => {
    if (parseFloat(d?.value) > 0) {
      setState((prevState) => ({
        ...prevState,
        dividers: d,
      }));
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    const opt = _.filter(initialOptions, function (item) {
      if (service?.id === '62ac31041f1f25ecdc944b6a') {
        return (
          item?.value === 'dedicated_monthly' ||
          item?.value === 'dedicated_daily'
        );
      } else {
        return (
          item?.value !== 'dedicated_monthly' &&
          item?.value !== 'dedicated_daily'
        );
      }
    });

    setState((prevState) => ({ ...prevState, options: opt }));
  }, [service]);

  React.useEffect(() => {
    if (!data) return;

    divide = [
      { value: '4000', label: '4000' },
      { value: '6000', label: '6000' },
      { value: '1000000', label: '1000000' },
    ];

    const ps =
      data?.pricing_schema === 'weight_point_based'
        ? initialOptions[0]
        : data?.pricing_schema === 'weight_based'
        ? initialOptions[1]
        : data?.pricing_schema === 'trip_based'
        ? initialOptions[2]
        : data?.pricing_schema === 'colly_based'
        ? initialOptions[3]
        : data.pricing_schema === 'dedicated_monthly'
        ? initialOptions[4]
        : data.pricing_schema === 'dedicated_daily'
        ? initialOptions[5]
        : null;

    const dv =
      data?.dividers === 4000
        ? divide[0]
        : data?.dividers === 6000
        ? divide[1]
        : data?.dividers === 1000000
        ? divide[2]
        : divide?.push({
            value: data?.dividers,
            label: data?.dividers,
          })
        ? divide[3]
        : null;

    setState((prevState) => ({
      ...prevState,
      service: data?.service,
      pricing_schema: ps,
      dividers: dv,
      name: data?.name,
      min_weight: data?.min_weight,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <Modal.Body>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-12 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </Modal.Body>
    );
  }

  return (
    <>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <Select.Remote
                required
                isSearch={false}
                label="Pilih Jenis Layanan"
                placeholder=""
                url="/tms/service"
                value={service}
                params={{
                  service_id: service?.id,
                }}
                initialValue={service?.id || data?.service?.id}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d.name,
                  };
                }}
                onSelected={(c) => {
                  setState((prevState) => ({
                    ...prevState,
                    service: c,
                    dividers: null,
                  }));
                }}
                errors={StateForm?.errors?.service_id}
              />
            </div>
            <div className="mb-3">
              <Form.Input
                value={name || ''}
                horizontal
                required
                label="Nama Layanan"
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }))
                }
                type="text"
                error={StateForm?.errors?.name}
              />
            </div>
            {service?.id === '61bb02262a457fc68763b774' && (
              <div>
                <label className="form-label">Pilih Pembagi Volumetrik</label>
                <Select.Createable
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.dividers ? 'is-invalid' : 'select'
                  }
                  placeholder=""
                  value={dividers}
                  options={divide}
                  onChange={$handleChangeDivider}
                  error={StateForm?.errors?.dividers}
                />
                <small className="form-hint pt-1">
                  Silakan ketik pembagi volumetrik untuk buat baru
                </small>

                {StateForm?.errors?.dividers ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors?.dividers}
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button
              type="button"
              className="btn btn-light w-100"
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};

export default FormInput;
